var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2466 12.2529C22.2466 13.0568 22.0814 13.8527 21.7604 14.5954C21.4394 15.338 20.9689 16.0128 20.3758 16.5812C19.7827 17.1496 19.0786 17.6005 18.3037 17.9081C17.5287 18.2157 16.6982 18.374 15.8594 18.374",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2463 9.48511V12.2529C22.2442 13.1989 22.0123 14.1314 21.5688 14.9766C21.1254 15.8217 20.4826 16.5563 19.6914 17.122V20.9338L27.3453 23.0705C28.5706 23.5037 29.6278 24.2865 30.3746 25.3133C31.1213 26.3401 31.5217 27.5616 31.5217 28.8132V30.2436",
    stroke: "#EEEBE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.863281 30.2436V28.7825C0.863281 27.526 1.26676 26.3 2.01895 25.2708C2.77113 24.2417 3.83556 23.4593 5.06773 23.0299L12.7491 20.9338V17.1221C11.9579 16.5563 11.3151 15.8218 10.8717 14.9766C10.4282 14.1314 10.1962 13.1989 10.1942 12.2529V9.48511",
    stroke: "#EEEBE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8613 21.7809V28.9662",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19531 22.2595V28.9661",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1914 28.9661V22.2595",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5254 21.6208V28.9662",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8613 27.05H21.5252",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1914 27.05H26.8574V30.8824",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19527 27.05H5.5293V30.8824",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8828 21.3014C11.1091 23.2681 13.3976 24.8144 16.1923 24.8144C18.987 24.8144 21.2755 23.2681 21.5018 21.3014",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52708 30.8822C10.0792 30.8822 10.5268 30.4533 10.5268 29.9241C10.5268 29.395 10.0792 28.9661 9.52708 28.9661C8.97494 28.9661 8.52734 29.395 8.52734 29.9241C8.52734 30.4533 8.97494 30.8822 9.52708 30.8822Z",
    fill: "#EEEBE7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8572 30.8822C23.4093 30.8822 23.8569 30.4533 23.8569 29.9241C23.8569 29.395 23.4093 28.9661 22.8572 28.9661C22.305 28.9661 21.8574 29.395 21.8574 29.9241C21.8574 30.4533 22.305 30.8822 22.8572 30.8822Z",
    fill: "#EEEBE7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1953 7.56885H22.1922",
    stroke: "#EEEBE7",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1911 7.56885H8.19531",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52734 7.24953C9.52734 5.55553 10.2295 3.93091 11.4795 2.73307C12.7294 1.53524 14.4246 0.862305 16.1923 0.862305C17.9599 0.862305 19.6552 1.53524 20.9051 2.73307C22.155 3.93091 22.8572 5.55553 22.8572 7.24953",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8593 0.968994V4.3753H13.5273V0.968994",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06);
export default __webpack_public_path__ + "static/media/icon06.b4fcf63d31c7124ac14dd2649d70a093.svg";
export { ForwardRef as ReactComponent };